import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';

function createStore(initialState) {
  let state = initialState;
  const listeners = [];
  function setState(partial) {
    state = _objectSpread2(_objectSpread2({}, state), partial);
    for (const listener of listeners) {
      listener();
    }
  }
  function getState() {
    return state;
  }
  function subscribe(listener) {
    listeners.push(listener);
    return () => {
      const index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }
  return {
    setState,
    getState,
    subscribe
  };
}

export default createStore;
